import { Validator } from '@vista-digital/validator';
import { dropdownFieldDisplayTextValidatorSchema } from '../../form/field/dropdown/types/display-text';
import { radioGroupFieldDisplayTextValidatorSchema } from '../../form/field/radio-group/types/display-text';
export const defaultMemberFormGivenNameFieldDisplayText = {
    label: 'Given name',
    requiredMessage: 'Please enter your given name.',
    formatMessage: 'The given name you entered is invalid.',
    lengthMessage: 'Your given name must contain less than ${maxLength} characters.'
};
export const defaultMemberFormFamilyNameFieldDisplayText = {
    label: 'Family name',
    requiredMessage: 'Please enter your family name.',
    formatMessage: 'The family name you entered is invalid.',
    lengthMessage: 'Your family name must contain less than ${maxLength} characters.'
};
export const defaultMemberFormMobileNumberFieldDisplayText = {
    label: 'Mobile number',
    requiredMessage: 'Please enter your mobile number.',
    formatMessage: 'The mobile number you entered is invalid.',
    lengthMessage: 'Your mobile number must contain less than ${maxLength} characters.'
};
export const defaultMemberFormHomeNumberFieldDisplayText = {
    label: 'Home number',
    requiredMessage: 'Please enter your home number.',
    formatMessage: 'The home number you entered is invalid.',
    lengthMessage: 'Your home number must contain less than ${maxLength} characters.'
};
export const defaultMemberFormDateOfBirthFieldDisplayText = {
    label: 'Date of birth',
    requiredMessage: 'Please enter your date of birth.',
    formatMessage: 'The date of birth you entered is invalid.',
    minAgeMessage: 'You must be at least ${minAge} years old to sign up.'
};
export const defaultMemberFormGenderFieldDisplayText = {
    label: 'Gender',
    placeholder: 'Select your gender',
    femaleOptionLabel: 'Female',
    maleOptionLabel: 'Male',
    otherOptionLabel: 'Other',
    requiredMessage: 'Please select your gender.'
};
export const defaultMemberFormNationalIdFieldDisplayText = {
    label: 'National ID',
    requiredMessage: 'Please enter your national ID.',
    formatMessage: 'The national ID you entered is invalid.',
    lengthMessage: 'Your national ID must contain less than ${maxLength} characters.'
};
export const defaultMemberFormExternalIdFieldDisplayText = {
    label: 'External ID',
    requiredMessage: 'Please enter your external ID.',
    formatMessage: 'The external ID you entered is invalid.',
    lengthMessage: 'Your external ID must contain less than ${maxLength} characters.'
};
export const defaultMemberFormAddressFieldDisplayText = {
    label: 'Address',
    requiredMessage: 'Please enter your address.',
    formatMessage: 'The address you entered is invalid.',
    lengthMessage: 'Your address must contain less than ${maxLength} characters.'
};
export const defaultMemberFormSuburbFieldDisplayText = {
    label: 'Suburb',
    requiredMessage: 'Please enter your suburb.',
    formatMessage: 'The suburb you entered is invalid.',
    lengthMessage: 'Your suburb must contain less than ${maxLength} characters.'
};
export const defaultMemberFormCityFieldDisplayText = {
    label: 'City',
    requiredMessage: 'Please enter your city.',
    formatMessage: 'The city you entered is invalid.',
    lengthMessage: 'Your city must contain less than ${maxLength} characters.'
};
export const defaultMemberFormStateFieldDisplayText = {
    label: 'State',
    requiredMessage: 'Please enter your state.',
    formatMessage: 'The state you entered is invalid.',
    lengthMessage: 'Your state must contain less than ${maxLength} characters.'
};
export const defaultMemberFormPostCodeFieldDisplayText = {
    label: 'Post code',
    requiredMessage: 'Please enter your post code.',
    formatMessage: 'The post code you entered is invalid.',
    lengthMessage: 'Your post code must contain less than ${maxLength} characters.'
};
export const defaultMemberFormPrimarySiteFieldDisplayText = {
    label: 'Primary cinema',
    placeholder: 'Select your primary cinema',
    requiredMessage: 'Please select your primary cinema.'
};
export const defaultMemberFormFavouriteGenresFieldDisplayText = {
    label: 'Select your favourite genres',
    requiredMessage: 'Please select at least one of your favourite genres.'
};
export const defaultMemberFormNewsletterFieldDisplayText = {
    label: 'Yes, I would like to receive newsletters and promotional offers from ${cinemaChainName}.',
    requiredMessage: 'Please agree to receive the newsletter to continue.'
};
export const defaultMemberFormTermsAndConditionsFieldDisplayText = {
    label: 'Yes, I agree to the Terms and Conditions of ${cinemaChainName}',
    requiredMessage: 'Please agree to the terms and conditions to continue.'
};
export const defaultMemberFormAllowThirdPartyContactFieldDisplayText = {
    label: 'Yes, I would like to receive newsletters and promotional content from third-parties.',
    requiredMessage: 'Please agree to receive newsletters and promotional content from third-parties to continue.'
};
export const defaultMemberFormAllowThirdPartyProfilingFieldDisplayText = {
    label: 'Allow my data to be shared with ${cinemaChainName} market analysis partners.',
    requiredMessage: 'Please agree to allow your data to be shared with ${cinemaChainName} market analysis partners to continue.'
};
export const memberFormGenderFieldDisplayTextValidator = Validator.object({
    label: radioGroupFieldDisplayTextValidatorSchema.label,
    placeholder: dropdownFieldDisplayTextValidatorSchema.placeholder,
    requiredMessage: radioGroupFieldDisplayTextValidatorSchema.requiredMessage,
    noSearchResultsFoundMessage: dropdownFieldDisplayTextValidatorSchema.noSearchResultsFoundMessage,
    femaleOptionLabel: Validator.nonEmptyString,
    maleOptionLabel: Validator.nonEmptyString,
    otherOptionLabel: Validator.nonEmptyString
});
//# sourceMappingURL=display-text.js.map